const Aggression = require("../../entities/Aggression")
const { Age }  = require("../Constants");
const AggessionNames = require("../Names/AggressionNames");

class Spy extends Aggression {
    constructor() {
        super(
            Age.Age2,
            AggessionNames.Spy,
            1,
            "A rival loses up to 5 science. You score that many science.",
            {
                //effect
            }
        )
    }
}

module.exports = Spy;